<template>
  <div class="coperation-process-box">
    <div class="show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <span>合作流程</span>
          <strong></strong>
        </dt>
        <dd class="choose-answer show-flex-box-c">
          <strong>让我们携手同行，不忘初心，成为STEAM教育新时代的推动者。</strong>
        </dd>
        <dd class="choose-pic-box show-flex-box-r">
          <span>
            <img src="../../assets/home/coperation-process.png" alt="德阳经开科创" draggable="false">
          </span>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'coperation_process_cpn',
  data () {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .coperation-process-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .coperation-process-box{
    width: 100%;
    height: 462px;
    background: #fff;
    &>div{
      margin: 0 auto;
      width: 1200px;
      align-items: center;
      &>dl{
        width: 100%;
        align-items: center;
        &>dt{
          align-items: center;
          &>span{
            word-wrap: none;
            .coperation-process-font-style( 40px; bold; auto; #191D21 );
            padding-top: 82px;
          }
          &>strong{
            display: block;
            width: 130px;
            height: 5px;
            background: #FF7800;
            margin-top: 19px;
            margin-bottom: 38px;
          }
        }
        &>.choose-answer{
          align-items: center;
          padding-bottom: 45px;
          &>strong{
            .coperation-process-font-style( 18px; 400; 34px; #3E3A39 );
          }
        }
        &>.choose-pic-box{
          width: 100%;
          padding-bottom: 80px;
          justify-content: center;
          &>span{
            width: 856px;
            &>img{
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/coperation_process_cpn.vue